import { useState } from "react";
import CopyCode from "../CopyCode/CopyCode";
import Icon from "../Icon";

const CardComponent = () => {
	const [hoveredCard, setHoveredCard] = useState(null);

	return (
		<div className="flex flex-col gap-y-10 p-6">
			{/* SECTION 1: BASIC CARDS */}
			<div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
				<h2 className="text-xl font-bold text-white mb-6">Basic Cards</h2>
				<div className="grid grid-cols-1 md:grid-cols-2 gap-4">

					{/* Variation 1: Simple Card */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Simple Card</label>
						<div className="bg-slate-700 border border-slate-600 rounded-lg p-4 hover:border-amber-400/50 transition-all">
							<h3 className="font-semibold text-amber-300 mb-2">Card Title</h3>
							<p className="text-slate-300 text-sm">Simple card with title and description text.</p>
						</div>
								<CopyCode number_code={1} code={`<div className="bg-slate-700 border border-slate-600 rounded-lg p-4 hover:border-amber-400/50 transition-all">
  <h3 className="font-semibold text-amber-300 mb-2">Title</h3>
  <p className="text-slate-300 text-sm">Description</p>
</div>`} />
					</div>

					{/* Variation 2: Card with Header */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
						<label className="text-xs text-slate-400 mb-3 block font-medium">With Header</label>
						<div className="bg-slate-700 border border-slate-600 rounded-lg overflow-hidden hover:shadow-lg hover:shadow-amber-500/20 transition-all">
								<div className="bg-gradient-to-r from-amber-600 to-orange-600 p-4">
								<h3 className="font-semibold text-white">Featured Card</h3>
							</div>
							<p className="text-slate-300 text-sm p-4">Card with colored header section.</p>
						</div>
						<CopyCode number_code={2} code={`<div className="bg-slate-700 border border-slate-600 rounded-lg overflow-hidden">
  <div className="bg-gradient-to-r from-amber-600 to-orange-600 p-4">
    <h3 className="font-semibold text-white">Header</h3>
  </div>
  <p className="text-slate-300 text-sm p-4">Content</p>
</div>`} />
					</div>

					{/* Variation 3: Card with Footer */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
						<label className="text-xs text-slate-400 mb-3 block font-medium">With Footer</label>
								<div className="bg-slate-700 border border-slate-600 rounded-lg overflow-hidden hover:border-amber-400/50 transition-all">
									<div className="p-4">
										<h3 className="font-semibold text-amber-300 mb-2">Card Title</h3>
								<p className="text-slate-400 text-sm">Lorem ipsum dolor sit amet.</p>
							</div>
							<div className="border-t border-slate-600 p-4 flex gap-2">
										<button className="px-3 py-1 bg-amber-600 hover:bg-amber-700 text-white text-sm rounded">Action</button>
								<button className="px-3 py-1 bg-slate-600 hover:bg-slate-500 text-white text-sm rounded">Cancel</button>
							</div>
						</div>
						<CopyCode number_code={3} code={`<div className="bg-slate-700 border border-slate-600 rounded-lg overflow-hidden">
  <div className="p-4">
    <h3 className="font-semibold text-amber-300">Title</h3>
    <p className="text-slate-400 text-sm">Content</p>
  </div>
  <div className="border-t border-slate-600 p-4 flex gap-2">
    <button className="px-3 py-1 bg-amber-600 text-white text-sm rounded">Action</button>
  </div>
</div>`} />
					</div>

					{/* Variation 4: Image Card */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
						<label className="text-xs text-slate-400 mb-3 block font-medium">With Image</label>
						<div className="bg-slate-700 border border-slate-600 rounded-lg overflow-hidden hover:shadow-lg transition-all">
							<div className="w-full h-32 bg-gradient-to-br from-amber-500 to-amber-600 flex items-center justify-center text-2xl">
								<Icon name="image" className="w-8 h-8" />
							</div>
							<div className="p-4">
									<h3 className="font-semibold text-amber-300">Image Card</h3>
								<p className="text-slate-400 text-sm mt-2">Card with image placeholder.</p>
							</div>
						</div>
						<CopyCode number_code={4} code={`<div className="bg-slate-700 border border-slate-600 rounded-lg overflow-hidden">
  <div className="w-full h-32 bg-gradient-to-br from-amber-500 to-amber-600">
    <!-- Image here -->
  </div>
  <div className="p-4">
    <h3 className="font-semibold text-amber-300">Title</h3>
  </div>
</div>`} />
					</div>

					{/* Variation 5: Minimal Card */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Minimal Style</label>
						<div className="border-l-4 border-l-amber-400 bg-slate-700/50 p-4 rounded hover:bg-slate-700 transition-all">
							<h4 className="font-semibold text-slate-100">Minimal Design</h4>
							<p className="text-slate-400 text-sm mt-1">Clean and simple card design.</p>
						</div>
								<CopyCode number_code={5} code={`<div className="border-l-4 border-l-amber-400 bg-slate-700/50 p-4 rounded">
  <h4 className="font-semibold text-slate-100">Title</h4>
  <p className="text-slate-400 text-sm mt-1">Content</p>
</div>`} />
					</div>

					{/* Variation 6: Gradient Border Card */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Gradient Border</label>
						<div className="bg-gradient-to-br from-amber-500/20 to-amber-500/20 border border-amber-500/50 rounded-lg p-4 hover:to-amber-500/20 transition-all">
							<h3 className="font-semibold text-amber-300 mb-2">Gradient Card</h3>
							<p className="text-slate-300 text-sm">Card with gradient border effect.</p>
						</div>
						<CopyCode number_code={6} code={`<div className="bg-gradient-to-br from-amber-500/20 to-amber-500/20 border border-amber-500/50 rounded-lg p-4">
  <h3 className="font-semibold text-amber-300">Title</h3>
  <p className="text-slate-300 text-sm">Content</p>
</div>`} />
					</div>

				</div>
			</div>

			{/* SECTION 2: ADVANCED CARDS */}
			<div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
				<h2 className="text-xl font-bold text-amber-400 mb-6 flex items-center gap-2"><Icon name="sparkles" className="w-5 h-5" /> Advanced Variations</h2>
				<div className="grid grid-cols-1 md:grid-cols-2 gap-4">

					{/* Variation 7: Hover Lift Card */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Hover Lift Effect</label>
						<div className="bg-slate-700 border border-slate-600 rounded-lg p-4 hover:-translate-y-2 hover:shadow-xl hover:shadow-amber-500/20 transition-all cursor-pointer">
							<div className="text-3xl mb-2"><Icon name="sparkles" className="w-7 h-7" /></div>
							<h3 className="font-semibold text-amber-300">Hover Effect</h3>
							<p className="text-slate-400 text-sm mt-2">Lifts on hover with shadow.</p>
						</div>
						<CopyCode number_code={7} code={`<div className="bg-slate-700 border border-slate-600 rounded-lg p-4 hover:-translate-y-2 hover:shadow-xl hover:shadow-amber-500/20 transition-all">
  <!-- Content -->
</div>`} />
					</div>

					{/* Variation 8: Stat Card */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Stat Card</label>
						<div className="bg-gradient-to-br from-slate-700 to-slate-800 border border-slate-600 rounded-lg p-6 text-center hover:border-amber-500/50 transition-all">
							<div className="text-4xl font-bold text-amber-400 mb-2">2.5K</div>
							<div className="text-slate-400 text-sm">Active Users</div>
							<div className="text-xs text-slate-500 mt-2 inline-flex items-center gap-1"><Icon name="arrowUp" className="w-3 h-3" /> 12% this month</div>
						</div>
						<CopyCode number_code={8} code={`<div className="bg-gradient-to-br from-slate-700 to-slate-800 border border-slate-600 rounded-lg p-6 text-center">
  <div className="text-4xl font-bold text-amber-400">2.5K</div>
  <div className="text-slate-400">Active Users</div>
	<div className="text-xs text-slate-500 mt-2">12%</div>
</div>`} />
					</div>

					{/* Variation 9: Multi-Column Card */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Multi-Column</label>
						<div className="bg-slate-700 border border-slate-600 rounded-lg overflow-hidden hover:border-amber-500/50 transition-all">
							<div className="grid grid-cols-2 gap-px bg-slate-600">
								<div className="bg-slate-700 p-4">
									<div className="text-amber-400 font-semibold">Left</div>
									<p className="text-slate-400 text-xs mt-1">Column 1</p>
								</div>
								<div className="bg-slate-700 p-4">
									<div className="text-blue-400 font-semibold">Right</div>
									<p className="text-slate-400 text-xs mt-1">Column 2</p>
								</div>
							</div>
						</div>
						<CopyCode number_code={9} code={`<div className="grid grid-cols-2 gap-px bg-slate-600">
  <div className="bg-slate-700 p-4">
    <div className="text-amber-400 font-semibold">Left</div>
  </div>
  <div className="bg-slate-700 p-4">
    <div className="text-blue-400 font-semibold">Right</div>
  </div>
</div>`} />
					</div>

					{/* Variation 10: Stacked Info Card */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Stacked Info</label>
						<div className="bg-slate-700 border border-slate-600 rounded-lg divide-y divide-slate-600 hover:shadow-lg hover:shadow-amber-500/20 transition-all">
							<div className="p-4 flex justify-between items-center">
								<span className="text-slate-300">Status</span>
								<span className="text-green-400 font-semibold">Active</span>
							</div>
							<div className="p-4 flex justify-between items-center">
								<span className="text-slate-300">Updated</span>
								<span className="text-slate-400 text-sm">2 hours ago</span>
							</div>
						</div>
						<CopyCode number_code={10} code={`<div className="bg-slate-700 border border-slate-600 rounded-lg divide-y divide-slate-600">
  <div className="p-4 flex justify-between">
    <span>Status</span>
    <span className="text-green-400">Active</span>
  </div>
  <div className="p-4 flex justify-between">
    <span>Updated</span>
    <span>2 hours ago</span>
  </div>
</div>`} />
					</div>

					{/* Variation 11: Dark No Border Card */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
						<label className="text-xs text-slate-400 mb-3 block font-medium">No Border</label>
						<div className="bg-slate-800 rounded-lg p-4 hover:bg-slate-750 transition-all">
							<div className="flex items-center gap-3">
								<div className="w-10 h-10 bg-gradient-to-br from-amber-500 to-blue-500 rounded-lg flex items-center justify-center">
									<Icon name="lightbulb" className="w-5 h-5" />
								</div>
								<div>
									<h3 className="text-slate-100 font-semibold text-sm">Borderless</h3>
									<p className="text-slate-400 text-xs">Clean minimal look</p>
								</div>
							</div>
						</div>
						<CopyCode number_code={11} code={`<div className="bg-slate-800 rounded-lg p-4">
  <div className="flex items-center gap-3">
    <div className="w-10 h-10 bg-gradient-to-br from-amber-500 to-blue-500 rounded-lg">
	Icon
    </div>
    <div>
      <h3 className="text-slate-100 font-semibold text-sm">Title</h3>
      <p className="text-slate-400 text-xs">Subtitle</p>
    </div>
  </div>
</div>`} />
					</div>

					{/* Variation 12: Interactive Card */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Interactive</label>
						<div 
							onMouseEnter={() => setHoveredCard('card12')}
							onMouseLeave={() => setHoveredCard(null)}
							className="bg-slate-700 border border-slate-600 rounded-lg p-4 cursor-pointer transition-all"
						>
							<div className="flex items-start justify-between mb-2">
								<h3 className="font-semibold text-slate-100">Interactive Card</h3>
								<span className={`transition-transform ${hoveredCard === 'card12' ? 'scale-110' : ''}`}><Icon name="star" className="w-4 h-4" /></span>
							</div>
							<p className="text-slate-400 text-sm">Click to interact with card.</p>
						</div>
						<CopyCode number_code={12} code={`<div 
  onMouseEnter={() => setState(true)}
  onMouseLeave={() => setState(false)}
  className="bg-slate-700 border border-slate-600 rounded-lg p-4"
>
  <h3 className="font-semibold">Interactive</h3>
</div>`} />
					</div>

				</div>
			</div>
		</div>
	);
};

export default CardComponent;



